// extracted by mini-css-extract-plugin
export var askAiIcon = "_oh-j";
export var category = "_oh-9";
export var categoryHeader = "_oh-e";
export var container = "_oh-0";
export var group = "_oh-a";
export var groupItems = "_oh-f";
export var groupSeparator = "_oh-k";
export var loading = "_oh-1";
export var noResults = "_oh-3";
export var placeholder = "_oh-2";
export var resultContent = "_oh-5";
export var resultIcon = "_oh-c";
export var resultItem = "_oh-g";
export var resultMeta = "_oh-8";
export var resultSubtitle = "_oh-7";
export var resultSuffix = "_oh-i";
export var resultTitle = "_oh-6";
export var resultsList = "_oh-4";
export var searchGroup = "_oh-d";
export var selected = "_oh-h";
export var subgroup = "_oh-b";